var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { addCommentRequest } from "../../api/api";
function useCommentActions() {
    const addComment = (typeId, type, isPrivate, commentText) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield addCommentRequest(typeId, type, isPrivate, commentText);
            toast.success(__("Comment added", "quicktasker"));
            return response.data;
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to add comment", "quicktasker"));
        }
    });
    return {
        addComment,
    };
}
export { useCommentActions };
